export const RETURN_CODE = {
	success:200,//数据返回成功
	sys_error:2,//系统错误,前端显示服务器提示信息
	param_error:1,//参数错误,前端显示服务器提示信息
	no_login:3,//token错误,前端跳转微信登录页面
};